import { SEARCHES, SINGLE_SUBURB } from '@domain-group/fe-allhomes-library/lib/utils/page-regexes';
var generateBackToSearch = referrer => {
  var link = null;
  var text = null;
  var useBack = false;
  if ([...SEARCHES, SINGLE_SUBURB].some(regex => regex.test(referrer))) {
    // Coming from search page
    useBack = true;
    text = 'Back to Search';
    link = referrer;
  }
  return {
    link,
    text,
    useBack
  };
};
export default generateBackToSearch;